import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';

export interface IconAndDescriptionProps {
  icon?: ImageProps;
  description: string;
  label?: string;
}
export const GriddleIconDescription = ({ icon, description, label }: IconAndDescriptionProps) => {
  if (!description) return null;
  return (
    <div className="tw-gap-2 tw-flex tw-flex-col sm:tw-gap-6 sm:tw-grid sm:tw-grid-cols-[1fr_2fr] tw-max-w-smallBody tw-m-auto">
      <div className="tw-bg-neutral-600 tw-flex tw-flex-col tw-justify-center tw-p-4 md:tw-p-8 tw-items-center">
        {icon && (
          /* eslint-disable-next-line @next/next/no-img-element */
          <img src={buildImageSrc(icon, 600, 0, 0)} alt={icon.altTag} />
        )}
        {label && <h4 className="tw-text-neutral-100 tw-pt-4 sm:tw-pt-6">{label}</h4>}
      </div>
      <div className="tw-bg-neutral-600 tw-flex tw-flex-col tw-justify-center tw-p-4 md:tw-p-8">
        <p className="tw-text-neutral-100 tw-mb-0 tra-text-web-body-xl">{description}</p>
      </div>
    </div>
  );
};

export default GriddleIconDescription;
